import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TooltipModule } from 'ngx-bootstrap';
import { BlNgCommonModule } from '@blcloud/bl-ng-common';
import { BlNgUiComponentModule } from '@blcloud/bl-ng-ui-component';
import { SalesSlipSearchScreenActionSettingModalComponent } from './sales-slip-search-screen-action-setting-modal.component';
import { SalesSlipSearchScreenActionSettingService } from './sales-slip-search-screen-action-setting-modal.service';

/**
 * 伝票検索画面動作設定モジュール
 */
@NgModule({
  imports: [
    CommonModule,
    BlNgCommonModule,
    BlNgUiComponentModule,
    TooltipModule
  ],
  declarations: [
    SalesSlipSearchScreenActionSettingModalComponent
  ],
  entryComponents: [
    SalesSlipSearchScreenActionSettingModalComponent
  ],
})
export class SalesSlipSearchScreenActionSettingModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SalesSlipSearchScreenActionSettingModule,
      providers: [
        SalesSlipSearchScreenActionSettingService,
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/sales-slip-search-screen-action-setting-modal/sales-slip-search-screen-action-setting-modal.module.ts